import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const MaterialForm_Material_Foau_Mutation = graphql(`
  mutation MaterialForm_Material_Foau(
    $filter: IdFilterInput!
    $update: MaterialInput!
    $versionData: VersionDataInput
  ) {
    findOneAndUpdateMaterial(
      filter: $filter
      update: $update
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export type MaterialForm_Material_Foau_Result = ResultOf<
  typeof MaterialForm_Material_Foau_Mutation
>;

export const useUpdateMaterialMutation = () =>
  useGraphQLMutation(MaterialForm_Material_Foau_Mutation);
